<template>
    <li class="font-semibold">
        <router-link :to="to" :class="['btn', customClass]" :target="newTab ? '_blank' : ''">
            <div class="container-faw relative">
                <span v-if="notif" class="absolute -right-2 -top-1 text-[#fff] bg-primary w-3.5 h-3.5 flex justify-center items-center rounded-full text-[10px]">
                    {{notif}}
                </span>
                <font-awesome-icon :icon="icon" class="font-aw"/> 
            </div>
            <div>{{ label }}</div>
        </router-link>
    </li>
</template>

<script>
export default {
    name: 'NavLink',
    props: {
        to: {
            type: Object,
            required: true
        },
        icon: {
            type: Array,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        customClass: { // Renamed from 'class' to 'customClass'
            type: String,
            required: false,
            default: ''
        },
        notif: {
            type: Number,
            required: false,
            default: 0
        },
        newTab: {
            type: Boolean,
            required: false,
            default: false
        }
    },
}
</script>